import { useSelector } from 'react-redux';
import { selectRole, selectCanEditDoc } from '../../../redux/collab/collab.selectors';

// Returns { role, canEdit } based purely on the collaborator role. Read-only reasons
// (e.g. an archived diagram) are a separate concern — see selectIsDiagramReadOnly.
// role is one of 'view' | 'comment' | 'edit' | 'admin' | 'owner' | null.
export function useRole() {
    const role = useSelector(selectRole);
    const canEdit = useSelector(selectCanEditDoc);
    return { role, canEdit };
}
